<template>
  <section class="map-wrapper">
    <div id="new-nav">
      <sgs-nav :modules="modules" :title="title" :imgSrc="imgSrc" :userInfo="userInfo" :userMsgCount="userMsgCount"
        :userBarLocation="userBarLocation" :navBarLocation="navBarLocation" :loginUrl="loginUrl"></sgs-nav>
    </div>
    <div class="map-container">
      <el-aside class="nav-aside sgs-nav-style-el" width="75px" v-show="isShow">
        <el-menu class="nav-menu  sgs-nav-style-el" :default-active="activeIndex">
          <el-menu-item v-for="(item, index) in menus" :index="item.href" :key="index" @click="siderbarClick(item)"
            id="el-item">
            <i :class="item.css"></i>
            <p>{{ item.name }}</p>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="map-main">
        <router-view></router-view>
      </el-main>
      <div class="show-hide-icon" @mouseenter="handleMouseEnter" v-show="!isShow"></div>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Geoesbmengine } from "@/config/app-config";
import { apicurStyle, getUserMessage } from "@/apis/api";
import { Cas } from "@/config/app-config";
let host = APPCONFIG.IP,
  casLogout = Cas.location + "/logout";

export default {
  name: "SkyMap",
  data() {
    return {
      imgSrc: APPCONFIG.logo,
      title: "",
      input4: "",
      userMsgCount: 0,
      userBarLocation: GeoESB.Sites.Webmain, //此处配置从webframe/global-config.js获取，全站点一致
      navBarLocation: host,
      loginUrl: this.userInfo
        ? casLog.out + "?userid=" + this.userInfo.pkid
        : casLogout,
      menus: [],
      activeIndex: 'query',
      isShow:false,
    };
  },
  watch: {
    modules(val) {
      if (val) {
        this.getMapModule();
      }
    },
  },
  computed: {
    ...mapState({
      modules: (state) => state.user.modules,
      userInfo: (state) => state.user.userInfo,
    }),
  },
  async created() {
    if (!this.userInfo) {
      await this.$store.dispatch('getUserInfo').then((res) => {
        EventBus.$emit('sgs-user-init', res);
        this.getCurStyle();
        this.getMapModule();
      });
    }
    setInterval(this.getUserMessage, 8000);
  },
  mounted() {
    EventBus.$on("activeMenu-clear", this.resetActiveName);
    EventBus.$on("hide-aside", this.hideAside);
    this.activeIndex = this.$route.path == '/home' ? '/map' : this.$route.fullPath;
  },
  beforeDestroy() {
    EventBus.$off("activeMenu-clear", this.resetActiveName);
  },
  methods: {
    ...mapMutations(['toggleFlag', 'changeShowMenu']),
    getCurStyle() {
      apicurStyle().then((res) => {
        // this.title = APPCONFIG.title || res.data.resultInfo.data.title;
        this.title = APPCONFIG.title;
      });
    },
    getMapModule() {
      if (this.modules) {
        let item = this.modules.filter((mo) => {
          return mo.pkid == APPCONFIG.mapId || mo.name == "数据中心";
        });
        if (item.length) {
          this.menus = JSON.parse(JSON.stringify(item[0].children));
          this.menus.forEach(item => {
            switch (item.css) {
              case 'icon-menu':
                item.css = 'side-map';
                break;
              case 'icon-edit':
                item.css = 'side-mymap';
                break;
              case 'el-icon-upload':
                item.css = 'side-data';
                break;
              case 'fa fa-thumb-tack':
                item.css = 'side-tag';
                break;
              case 'fa fa-line-chart':
                item.css = 'side-analysis';
                break;
            }
          });
          if (this.SeparateCesium) {
            this.menus.splice(1, 0, {
              name: "三维场景",
              href: "/scene",
              isAuto: true,
              css: "fa fa-globe"
            });
          }
        }
      }
    },
    siderbarClick(node) {
      this.activeIndex = node.href;
      if (!(this.$route.path === '/scene' && node.href === '/map?type=upload')) {
        this.toggleFlag({ name: 'showUploadMenu', flag: false });
        this.$router.push({ path: node.href });
      } else {
        this.toggleFlag({ name: 'showUploadMenu', flag: true });
      }
      if (node.href === '/map?type=mark') {
        this.changeShowMenu(true);
      }
      EventBus.$emit("clearTools");
    },
    getUserMessage() {
      if (this.userInfo) {
        getUserMessage().then((res) => {
          let result = res.data.resultInfo;
          if (result.success) {
            let count = result.data.sum;
            if (count > 99) {
              this.userMsgCount = "99+";
            } else {
              this.userMsgCount = count;
            }
          }
        });
      }
    },
    //三角显示符号移入
    handleMouseEnter(){
      this.isShow = true;
    },
    // 左侧功能隐藏
    hideAside(){
      this.isShow = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.map-wrapper {
  height: 100%;
}

#new-nav {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 59px;
  position: relative;
}

.map-container {
  height: calc(100% - 59px);
  display: flex;
}

.nav-aside {
  flex-shrink: 0;
}

.map-main {
  padding: 0px;
  flex: 1;
  position: relative;
}

.sgs-nav-style-el .el-menu .el-menu-item:focus,
.sgs-nav-style-el .el-menu .el-menu-item:hover,
.sgs-nav-style-el .el-menu .el-menu-item.is-active {
  background: #FFFFFF !important;
}
</style>

<style lang="scss">
.nav-aside {
  background: #4072bb;

  .nav-menu {
    top: 20px;
    background: #4072bb;

    li.is-active,
    li:hover {
      background: rgb(51, 153, 240);
    }
  }

  .menu li.is-active,
  .menu li:hover {
    background: #3399f0;
  }
}
.show-hide-icon{
    position: absolute;
    left: 0px;
    z-index: 99998;
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-left: 20px solid rgb(80, 153, 234);
    border-bottom: 20px solid transparent;
    display: inline-block;
    vertical-align: middle;
}
.show-hide-icon::after{
    position: absolute;
    left: 0px;
    z-index: 99998;
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-left: 20px solid rgb(194, 99, 44);
    border-bottom: 20px solid transparent;
    display: inline-block;
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/home/index-sky.vue